module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "tocheading"
  }, [_c('span', {
    staticClass: "chaps"
  }, [_vm._v("C")]), _vm._v("ONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_List_of_abbreviations"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Prolog"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("one")]), _vm._v(" War Comes to the Columbia Country")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("two")]), _vm._v(" Empire of the Seas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("three")]), _vm._v(" Man-of-War Diplomacy in the Oregon Crisis")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("four")]), _vm._v(" Colonizing the Perfect Eden")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("five")]), _vm._v(" War with Russia in the Pacific")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("six")]), _vm._v(" Gold-Rush Crises")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("seven")]), _vm._v(" Pig War on the San Juan Islands")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("eight")]), _vm._v(" Send a Gunboat!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("nine")]), _vm._v(" Esquimalt, Anchor of Empire")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("ten")]), _vm._v(" No Need for Glory: Anglo-American Tensions")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn_1"
  }, [_vm._v("eleven")]), _vm._v(" The Lengthening Shadows: Armageddon Approaches")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Appendix_A",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("APPENDIX A")]), _vm._v(" Changing Boundaries of the Pacific Station")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Appendix_B",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("APPENDIX B")]), _vm._v(" Pacific Station: Ships and Complements, 1847–1867")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Appendix_C",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("APPENDIX C")]), _vm._v(" Distribution of the Royal Navy, 1861–1874")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Appendix_D",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("APPENDIX D")]), _vm._v(" Commanders-in-Chief and Senior Naval Officers: Pacific Station, 1837–1914")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix_E",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("APPENDIX E")]), _vm._v(" Changing Technology in British Warships, 1810–1914")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix_F",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("APPENDIX F")]), _vm._v(" British Warships on the Northwest Coast of North America or in British Columbia Waters, 1778–1908")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Appendix_G",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("APPENDIX G")]), _vm._v(" Types and Classes of British Warships on the Northwest Coast of North America or in British Columbia Waters, 1778–1914")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0